import { useEffect, useState } from "react";
import { Link, useNavigate, useRouteLoaderData, useSubmit } from "react-router-dom";
import { saveAs } from "file-saver";
import { useUiStore } from "src/components/main/uiStore";
//--------------------------------------------------------------------------------------------
import { ReactComponent as Upload } from "src/img/svg/upload.svg";
import { ReactComponent as Download } from "src/img/svg/download.svg";
import UserInfo from "src/components/common/userInfo";
import Profile from "src/components/common/profile";
import { useAuthStore, User } from "src/components/main/authStore";
import { useUploadStore } from "src/components/main/uploadStore";
import { myAxios, getFileNameFromUrl } from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
type purchase = {id: number, poNumber: string, total: number};
export default function UserDetail(){
    const submit = useSubmit();
    const navigate = useNavigate();
    const [user, setUser] = useState<Partial<User> | undefined>(useRouteLoaderData("user"));
    const [purchaseList, setPurchaseList] = useState<purchase[]>([]);
    const upload = useUploadStore();
    const curUser = useAuthStore(state => state.user) as User;
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const handleDelete = () => {
        if(!user || !user.id) return;
        if(!window.confirm("If the user is left, you can set a left date when edit. Do you still want to delete this user?")) return;
        const formData = new FormData();
        formData.append("id", user.id);
        submit(formData, {
            method: "post",
            action: "Delete"
        });
    };
    const handleValidate = () => {
        if(!user || !user.id) return;
        if(!window.confirm("Are you sure to validate this user?")) return;
        let validateReason = window.prompt("reason to validdate:");
        if(validateReason === null) return;
        while(validateReason === ""){
            window.alert("Reason is required to validate.");
            validateReason = window.prompt("reason to validate:");
            if(validateReason === null) return;
        }
        const formData = new FormData();
        formData.append("validateReason", validateReason);
        formData.append("id", user.id);
        submit(formData, {
            method: "post",
            action: "Validate"
        });
        setUser({ ...user, void: "no", validateReason });
    }
    const handleVoid = () => {
        if(!user || !user.id) return;
        if(!window.confirm("Are you sure to void this user?")) return;
        let voidReason = window.prompt("reason to void:");
        if(voidReason === null) return;
        while(voidReason === ""){
            window.alert("Reason is required to void.");
            voidReason = window.prompt("reason to void:");
            if(voidReason === null) return;
        }
        const formData = new FormData();
        formData.append("voidReason", voidReason);
        formData.append("id", user.id);
        submit(formData, {
            method: "post",
            action: "Void"
        });
        setUser({ ...user, void: "yes", voidReason });
    }
    const handleUpdateMVR = async (target: HTMLInputElement | DataTransfer): Promise<void> => {
        if(!user || !user.id) return;
        const files = target.files;
        if(!files || !files.length || !files[0] || !files[0].name) return;
        const file = files[0];
        if(user.hasMVR && !window.confirm(`Are you sure to overwrite the existing MVR of ${user.userName}?`)) return;
        const formData = new FormData();
        formData.append("curUserId", user.id);
        formData.append("fileName", file.name);
        formData.append("fileType", file.type);
        formData.append("fileSize", String(file.size));
        formData.append("lastModifiedAt", (new Date(file.lastModified)).toISOString().slice(0, 19).replace('T', ' '));
        setShowLoader(true);
        const preRes = await myAxios({ fileName: "users/createMVR.php", formData: formData });
        setShowLoader(false);
        if(!preRes) return;
        upload.setUrls([preRes.data.url]);
        upload.setIds([preRes.data.id]);
        upload.setFiles([file]);
        upload.setShow(true);
        upload.setOnResetCallback(() => {
            setUser({ ...user, hasMVR: preRes.data.id });
            (target as HTMLInputElement).value = "";
        });
    }
    const handleDeleteMVR = async() => {
        if(!user || !user.id) return;
        if(!window.confirm(`Are you sure to delete the existing MVR of ${user.userName}?`)) return;
        const formData = new FormData();
        formData.append("curUserId", user.id);
        //---------------------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios({ fileName: "users/deleteMVR.php", formData: formData });
        setShowLoader(false);
        if(!res) return;
        //---------------------------------------------------------------------
        setUser({ ...user, hasMVR: ""});
    }
    const handleDownloadMVR = async() => {
        if(!user || !user.id) return;
        const formData = new FormData();
        formData.append("curUserId", user.id);
        setShowLoader(true);
        const preRes = await myAxios({ fileName: "users/getMVR.php", formData: formData });
        setShowLoader(false);
        if(!preRes) return;
        const url = preRes.data;
        try{
            const response = await fetch(url);
            if(!response.ok) throw new Error("Failed to fetch file");
            saveAs(await response.blob(), getFileNameFromUrl(url) || "download");
        }catch(error){
            window.alert("Error downloading file:" + error);
        }
    }
    const handleUpdateProfile = async (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
        if(!user || !user.id) return;
            const files = event.currentTarget.files;
            if(!files || !files.length || !files[0] || !files[0].name) return;
            const file = files[0];
            const formData = new FormData();
            formData.append("curUserId", user.id);
            formData.append("fileName", file.name);
            formData.append("fileSize", String(file.size));
            formData.append("fileType", file.type);
            formData.append("lastModifiedAt", (new Date(file.lastModified)).toISOString().slice(0, 19).replace('T', ' '));
            setShowLoader(true);
            const preRes = await myAxios({ fileName: "auth/updateProfile.php", formData: formData });
            setShowLoader(false);
            if(!preRes) return;
            upload.setIds([preRes.data.id]);
            upload.setUrls([preRes.data.url]);
            upload.setFiles([file]);
            upload.setShow(true);
            upload.setOnResetCallback(() => {
                const reader = new FileReader();
                reader.onload = () => {
                    setUser({...user, profileUrl: preRes.data.publicUrl});
                }
                reader.readAsDataURL(file);
            });
        }
    const handleDeleteProfile = async() => {
        if(!user) return;
        if(!window.confirm("Are you sure to delte this profile?")) return;
        const formData = new FormData();
        formData.append("curUserId", user.id ?? "");
        //-----------------------------------
        setShowLoader(true);
        const res = await myAxios({ fileName: "auth/deleteProfile.php", formData: formData });
        setShowLoader(false);
        if(!res) return;
        //-----------------------------------
        setUser({...user, profileUrl: ""});
    }
    const handleResendVerificationCode = async() => {
        if(!user) return;
        const formData = new FormData();
        formData.append("userEmail", user.email ?? "");
        setShowLoader(true);
        const res = await myAxios({ fileName: "users/resendVerificationCode.php", formData: formData });
        setShowLoader(false);
        if(!res) return;
    }
    useEffect(() => {
        if(!user){
            navigate("..", {replace: true});
            return;
        }
        let isMounted = true;
        const getData = async() => {
            //-----------------------------------
            setShowLoader(true);
            const formData = new FormData();
            formData.append("curUserId", user.id ?? "");
            const resPurchases = await myAxios({ fileName: "users/readPurchases.php", formData: formData });
            if(!isMounted) return;
            setShowLoader(false);
            if(!resPurchases) return;
            //-----------------------------------
            setPurchaseList(resPurchases.data);
        }
        if(user.btlNumber) getData();
        return () => {isMounted = false;}
    }, [setShowLoader, user, navigate])
    return(user? <div className = "px-3 py-2">
        <h1>
            Detail
        </h1>
        <div>
            {user.profileUrl && <Profile
                value = {`${user.profileUrl}?v=${Date.now()}`}
                side = {100}
            />}
        </div>
        <div style = {{display: "flex"}}>
            <div className="flex-grow-1 me-3">
                <div className = "text-center h5 fw-bold mt-3">Detail Information</div>
                <table className = "table table-responsive-xl">
                    <tbody>
                        <tr>
                            <th>Name</th>
                            <td className = "text-nowrap">{user.userName}</td>
                        </tr>
                        <tr>
                            <th>Email Address</th>
                            <td className = "user-select-text"><a href = {`mailto:${user.email}`} children = {user.email}/></td>
                        </tr>
                        {user.phoneNumber?
                        <tr>
                            <th>Mobile Phone</th>
                            <td><a href = {`tel:+1${user.phoneNumber}`} children = {user.phoneNumber}/></td>
                        </tr>
                        :null}
                        {user.workPhone?
                        <tr>
                            <th>Work Phone</th>
                            <td>
                                <a href = {`tel:+1${user.workPhone.replace(/-/g, "")}${user.extension?`,${user.extension}`:""}`}>
                                    {user.workPhone}{user.extension?` Ext. ${user.extension}`:null}
                                </a>
                            </td>
                        </tr>
                        :null}
                        <tr>
                            <th>Region</th>
                             <td>{user.region}</td>  
                        </tr>
                        <tr>
                            <th>Department</th>
                            <td>{user.department}</td>
                        </tr>
                        <tr>
                            <th>Role</th>
                            <td>{user.role}</td>
                        </tr>
                        <tr>
                            <th>Version</th>                  
                            <td>{user.version}</td>
                        </tr>
                        {user.unionName?
                        <tr> 
                            <th>Union</th>
                            <td>
                                <div><span className = "fw-bold me-3">Name:</span>{user.unionName}</div>
                                <div className = "mt-2"><span className = "fw-bold me-3">Level:</span>{user.phaseLevel}</div>
                            </td>
                        </tr>:null}
                        {user.address?
                        <tr> 
                            <th>Address</th>
                            <td>{user.address}</td>
                        </tr>
                        :null}
                        {user.outside !== "no"?
                        <tr>
                            <th>Outside Service</th>
                            <td>
                                <div><span className = "fw-bold me-3">Job Category:</span>{user.outside}</div>
                                <div className = "mt-2"><span className = "fw-bold me-3">Lan Id:</span>{user.lanId}</div>
                                <div className = "mt-2"><span className = "fw-bold me-3">BTL No.:</span>{user.btlNumber}</div>
                                <div className = "mt-2"><span className = "fw-bold me-3">Residence:</span>{[user.street, user.residence, user.residenceState, user.zipCode].filter(value => value).join(", ")}</div>
                            </td>
                        </tr>
                        :null}
                        <tr>
                            <th>Hire Date</th>
                            <td>{user.hireDate}</td>
                        </tr>
                        <tr>
                            <th>Quit Date</th>
                            <td>{user.quitDate?user.quitDate:""}</td>
                        </tr>
                        {curUser.personel === "edit"?<>
                        <tr>
                            <th>SSN</th>
                            <td>{user.ssn}</td>
                        </tr>
                        <tr> 
                            <th>Birthday</th>
                            <td>{user.birthDay}</td>
                        </tr>
                        <tr> 
                            <th>Driver License</th>
                            <td>{user.driverLicense}</td>
                        </tr>
                        <tr> 
                            <th>Void</th>
                            <td>{user.void}</td>
                        </tr>
                        {user.void === "yes" && user.voidReason && <tr> 
                            <th>Void Reason</th>
                            <td>{user.voidReason}</td>
                        </tr>}
                        {user.void === "no" && user.validateReason && <tr> 
                            <th>Validate Reason</th>
                            <td>{user.validateReason}</td>
                        </tr>}
                        {curUser.fleets === "edit"?
                        <tr>
                            <th style = {{verticalAlign: "middle"}}>MVR</th>
                            <td
                                onDragOver = {event => {
                                    event.stopPropagation();
                                    event.preventDefault();
                                }}
                                onDrop = {async event => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    handleUpdateMVR(event.dataTransfer);
                                }}
                            >
                                <button
                                    type = "button"
                                    onClick = {(event) => {(event.currentTarget.nextElementSibling as HTMLInputElement).click()}}
                                    className = "mb-0 btn btn-primary"
                                >
                                    <Upload/>
                                </button>
                                <input 
                                    id = {`uploadItemFiles ${user.email} mvr`} 
                                    type = "file" 
                                    style = {{display: "none"}} 
                                    onChange = {event => handleUpdateMVR(event.currentTarget)}
                                />
                                {user.hasMVR?
                                <>
                                <button
                                    onClick = {handleDownloadMVR}
                                    className = "btn btn-success ms-3"
                                >
                                    <Download/>
                                </button>
                                {curUser.fleets === "edit"?
                                <span
                                    className = "btn btn-danger ms-3"
                                    onClick = {handleDeleteMVR}
                                >
                                X
                                </span>
                                :<></>}
                                </>
                                :null}
                            </td>
                        </tr>
                        :<></>}
                        </>:null}
                        {user.updaterEmail?
                        <tr>
                            <th>Creator</th>
                            <td>
                                {user.creatorName && user.creatorId?
                                <UserInfo 
                                    name = {user.creatorName}
                                    id = {user.creatorId}
                                />
                                :null}
                                <span className = "ms-3">{user.dateCreated}</span>
                            </td>
                        </tr>
                        :<></>}
                        {user.updaterEmail?
                        <tr> 
                            <th>Updater</th>
                            <td>
                                {user.updaterName && user.updaterId?
                                <UserInfo 
                                    name = {user.updaterName}
                                    id = {user.updaterId}
                                />
                                :null}
                                <span className = "ms-3">{user.dateUpdated}</span>
                            </td>
                        </tr>
                        :<></>}
                    </tbody>
                </table>
                {curUser.personel === "edit"?
                <div>
                    <button
                        type = "button"
                        className = "btn btn-success"
                        onClick = {event => (event.currentTarget.nextElementSibling as HTMLInputElement).click()}
                    >
                        Upload Profile
                    </button>
                    <input
                        className = "nodisplay"
                        type = "file"
                        accept = "image/png, image/jpeg"
                        onChange = {handleUpdateProfile}
                    />
                    {user.profileUrl?
                    <button
                        type = "button"
                        className = "ms-3 btn btn-danger"
                        onClick = {handleDeleteProfile}
                    >
                        Delete Profile
                    </button>
                    :<></>}
                </div>
                :null}
                {user.btlNumber && purchaseList.length?
                <details className = "mt-4">
                    <summary className = "h5">Related Expense</summary>
                    <ul>
                        {purchaseList.map((p, pi) => 
                        <li key = {pi}>
                            <Link
                                to = {`/Purchases/${p.id}`}
                            >
                                {p.poNumber} &mdash; ${p.total}
                            </Link>
                        </li>)}
                    </ul>
                </details>
                :<></>}
            </div>
            <div className="flex-grow-1 me-3">
            <div className = "text-center h5 fw-bold mt-3">Access Control</div>
                <table className = "table table-responsive-xl">
                    <tbody>
                        <tr>
                            <th>Projects</th>
                            <td>{user.projects}</td>
                        </tr>
                        <tr>
                            <th>Assignments</th>
                            <td>{user.assignments}</td>
                        </tr>
                        <tr>
                            <th>Purchase</th>
                            <td>{user.purchases}</td>
                        </tr>
                        <tr>
                            <th>Per Diem</th>
                            <td>{user.perDiem}</td>
                        </tr>
                        <tr>
                            <th>Newspaper</th>
                            <td>{user.newspaper}</td>
                        </tr>
                        <tr>
                            <th>Fleets</th>
                            <td>{user.fleets}</td>
                        </tr>
                        <tr>
                            <th>Reports</th>
                            <td>{user.reports}</td>
                        </tr>
                        <tr>
                            <th>Users</th>
                            <td>{user.personel}</td>
                        </tr>
                        <tr>
                            <th>Calendar</th>
                            <td>{user.calendar}</td>
                        </tr>
                        <tr>
                            <th>Time Off</th>
                            <td>{user.timeOffs}</td>
                        </tr>
                        <tr>
                            <th>Office</th>
                            <td>{user.office}</td>
                        </tr>
                        <tr>
                            <th>Office Status</th>
                            <td>{user.allOffice}</td>
                        </tr>
                        <tr>
                            <th>Outside Service</th>
                            <td>{user.outside}</td>
                        </tr>
                        <tr>
                            <th>Outside Service Status</th>
                            <td>{user.outsideStatus}</td>
                        </tr>
                        <tr>
                            <th>Metrics</th>
                            <td>{user.metrics}</td>
                        </tr>
                        <tr>
                            <th>Trainings</th>
                            <td>{user.trainings}</td>
                        </tr>
                        {user.competencyServices?.length ? (
                        <tr>
                            <th>Competency</th>
                            <td>
                                {user.competencyServices.map((service, index) => (
                                    <span key = {service.value}>
                                        {index ? ", " : ""}
                                        <Link to = {`/Services/${service.value}`}>{service.label}</Link>
                                    </span>
                                ))}
                            </td>
                        </tr>
                        ) : null}
                    </tbody>
                </table>
            </div>
            <div className="d-flex flex-column flex-grow-1 maxWidth-50 me-3">
                <fieldset className="border rounded flex-grow-1 px-3">
                    <legend className="fw-bold">
                        Background
                    </legend>
                    <span className = "cssNotes">
                        {user.background}
                    </span>
                </fieldset>
            </div>
        </div>
        <div className="my-3">
            {curUser.personel === "edit" && 
                (user.void === "yes"?<>
                    <button
                        children = "Validate"
                        className = "btn btn-primary"
                        onClick = {handleValidate}
                    />
                    <button
                        children = "Delete"
                        className = "btn btn-danger ms-3"
                        onClick = {handleDelete}
                    />
                </>:
                <>
                {user.verificationCode !== null?
                <button className = "btn btn-info ms-3" onClick = {handleResendVerificationCode}>
                    Resend Verification Code
                </button>
                :null}
                <Link
                    children = "Edit"
                    to = "Edit"
                    className = "btn btn-outline-primary ms-3"
                />
                {user.dispatch === "1"?
                <Link children = "Edit Dispatch" to = "EditDispatch" className = "btn btn-primary m-3"/>
                :null}
                <button
                    children = "Void"
                    type = "button"
                    className = "btn btn-danger ms-3"
                    onClick = {handleVoid}
                />
                </>)
            }
            <Link
                children = "Back"
                to = ".."
                relative = "path"
                className = "btn btn-outline-secondary float-end"
            />
        </div>
    </div>:<></>)
}
